import { getInitialServerSideData } from "../../../shared/public/SlUtils/getInitialServerSideData";
import { Container, DataService, Service } from "../../../symphony";
import { AICoursesStore } from "../stores/ai-courses.store";
import { filter, take } from "rxjs/operators";

@Service()
export class AICoursesService {
  private store = Container.take('aicourses', AICoursesStore);
  private globalData = Container.take('global', DataService);

  public init = () => {
    const courses = getInitialServerSideData('ssrCourses');
    if (courses) {
      this.store.courses.next(courses);
    }
    this.globalData.learningExperiences$
      .pipe(
        filter(courses => !!courses),
        take(1)
      )
      .subscribe(courses => {
        this.store.courses.next(courses);
      });
  };
}